import React from 'react';
import { UilAngleDown } from '@iconscout/react-unicons';

const CategorySelector = ({
  selectedCategoryName,
  categories,
  isOpen,
  onToggle,
  onSelect
}) => {
  return (
    <div className="my-4">
      <label className="text-black font-medium">
        Select Category
      </label>
      <div className="inline-flex w-full">
        <div className="w-full relative inline-flex bg-white text-gray-900 border border-gray-400 mt-2 p-1 rounded-2xl hover:border-black focus:outline-none focus:shadow-outline">
          <button
            type="button"
            className="w-full rounded-l-md px-4 py-2 cursor-pointer text-left"
            onClick={() => onToggle(!isOpen)}
          >
            {selectedCategoryName || "Select Category"}
          </button>
          <div className="relative">
            <button
              type="button"
              onClick={() => onToggle(!isOpen)}
              className="border-1 border-gray-100 text-gray-600 inline-flex h-full items-center justify-center rounded-r-md px-2"
            >
              <UilAngleDown size="30" />
            </button>
          </div>

          {isOpen && categories && categories.length > 0 && (
            <div className="w-full absolute top-9 right-0 z-10 mt-4 origin-top-right text-gray-900 rounded-lg border border-gray-100 bg-white shadow-lg max-h-60 overflow-y-auto">
              {categories.map((item, i) => (
                <div key={i}>
                  <button
                    type="button"
                    onClick={() => {
                      if (item) {
                        onSelect(item.name);
                        onToggle(false);
                      }
                    }}
                    className="block rounded-lg w-full text-left px-4 py-3 text-sm text-gray-900 no-underline hover:bg-gray-100"
                  >
                    {item?.name || "Unknown Category"}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategorySelector;
